import React from "react";
import T from "prop-types";
import { Col, Row } from "react-bootstrap";
import DetailStat from "../DetailStat";
import { number } from "../format";
import { getFirstNameLastInitial } from "../../../../../lib/formatters/text";

const ExpertHeader = ({ experts }) => {
  if (!experts || experts.length === 0) return null;

  const header =
    experts.length === 1 ? "Resident Expert:" : "Resident Experts:";
  return [
    <h2
      style={{
        marginTop: 0,
        marginBottom: 0
      }}
    >
      {header}
    </h2>,
    <p
      className="lead text-blue"
      style={{
        fontSize: 14,
        fontStyle: "italic",
        marginBottom: 10
      }}
    >
      {experts.join(" / ")}
    </p>
  ];
};

export default function Detail({ stats, part }) {
  const experts =
    part &&
    [
      part.getIn(["resident_expert", "full_name"]),
      part.getIn(["second_resident_expert", "full_name"])
    ]
      .filter(n => n)
      .map(n => getFirstNameLastInitial(n));
  return (
    <Row>
      <Col md={2} sm={2}>
        {part && <ExpertHeader experts={experts} />}
      </Col>
      <DetailStat
        label="Sold in 12 mos."
        value={number(stats.sold_in_12_months)}
      />
      <DetailStat
        label="Sold in 4 mos."
        value={number(stats.sold_in_4_months)}
      />
      <DetailStat
        label="Avg # Days in Stk"
        value={number(stats.average_days_in_stock)}
      />
      <DetailStat
        label="Avg # OQs pr/mo"
        value={number(stats.average_oq_per_month)}
      />
      <Col md={2} sm={2}>
        &nbsp;
      </Col>
    </Row>
  );
}

Detail.propTypes = {
  stats: T.shape({}),
  part: T.shape({
    resident_expert: {
      full_name: T.string
    }
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/PartStats/Detail.jsx